import useBreakpoint from "hooks/useBreakpoint";

export const Footer = (props) => {
  const { isMobileAndTablet, isMobile } = useBreakpoint();
  return (
    <div
      style={{
        background: "linear-gradient(90deg, #161C5C 0%, #8001AB 100%)",
        fontFamily: "Poppins",
        ...(!isMobileAndTablet && {
          position: "absolute",
          bottom: "0",
          width: "100%",
        }),
        padding: "12px",
        marginTop: "12px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: isMobile ? "column" : "row",
          // borderTopStyle: "double",
          // borderWidth: "1px",
          // borderColor: "lightgray",
          // paddingTop: "8px",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "10px",
            flexDirection: isMobileAndTablet ? "column" : "row",
          }}
        >
          <p
            style={{
              // margin: "0 30px 0 0",
              ...(!isMobileAndTablet && {
                borderWidth: "1px",
                borderRightStyle: "double",
              }),
              paddingRight: "10px",
              color: "white",
              margin: "0",
            }}
          >
            <a
              href="https://lenny.ai/terms"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white" }}
            >
              Terms of Use
            </a>
          </p>
          <p
            style={{
              // margin: "0 30px 0 0",

              paddingRight: "10px",
              margin: "0",
              ...(!isMobileAndTablet && {
                borderWidth: "1px",
                borderRightStyle: "double",
              }),
            }}
          >
            <a
              href="https://lenny.ai/privacy"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white" }}
            >
              Privacy Policy
            </a>
          </p>
          <p
            style={{
              // margin: "0 30px 0 0",
              color: "white",
              cursor: "pointer",
              margin: "0",
            }}
            onClick={() => {
              window.open(
                "https://lenny.ai/do-not-sell-my-personal-information",
                "_blank"
              );
            }}
          >
            Do not Sell my Personal information
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: isMobileAndTablet ? "column" : "row",
            ...(isMobile && {
              marginTop: "10px",
            }),
          }}
        >
          <p style={{ color: "white", margin: "0" }}>
            Find More Scholarship on
          </p>
          <a href="https://lenny.ai/" target="_blank" rel="noopener noreferrer">
            <img
              src="/new/icon.png"
              style={{ height: "20px", margin: "2px 30px 0px 5px" }}
            />
          </a>
        </div>
      </div>
      <div
        style={{
          // marginTop: "8px",
          // margin: "8px 30px 0 0", // Same margin as the top div elements
          fontSize: "12px",
          color: "gray",
        }}
      >
        <p
          style={{
            margin: "0",
          }}
        >
          No purchase necessary to enter or apply for any scholarship or
          sweepstakes.
        </p>
      </div>
    </div>
  );
};
